import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { storeToRefs } from 'pinia';
import { useDetailStatusStore } from '@/store/detailStatus';
import DialogHeader from '@/components/dialog-header/index.vue';
import DetailStatus from '@/components/detail-status/index.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const detailStatusStore = useDetailStatusStore();
    const {
      isShowDetailStatus
    } = storeToRefs(detailStatusStore);
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(isShowDetailStatus),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(isShowDetailStatus) ? isShowDetailStatus.value = $event : null),
        "show-close": false,
        width: "90%",
        top: "3vh"
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(DialogHeader, {
          onClose: close,
          "header-name": "Check Status Detail",
          "guide-link": "/docs/keyPage/detailStatus.html"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createVNode(DetailStatus)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});